import { sliderMvBg } from "./namespace/sliderMvBg";
import { sliderCaseStudiesHeading } from "./namespace/sliderCaseStudiesHeading";
import { sliderDesignGallery } from "./namespace/sliderDesignGallery";
import { cardFlip } from "./namespace/cardFlip";
import { rollingCharacter } from "./namespace/rollingCharacter";
import { solutions } from "./namespace/solutions";
import { sliderOrderStart } from "./namespace/sliderOrderStart";
import { restartOrderButton } from "./namespace/restartOrderButton";
import { Reorder } from "./namespace/reorder";

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".p-mv")) {
    sliderMvBg();
    cardFlip();
    // TOPページでのRestartOrderButton初期化
    restartOrderButton();
  }
  if (document.querySelector(".p-case-studies")) {
    sliderCaseStudiesHeading();
  }
  if (document.querySelector(".p-design-gallery")) {
    sliderDesignGallery();
  }
  if (document.querySelector(".p-how-to-order")) {
    rollingCharacter();
  }
  if (document.querySelector(".p-solutions")) {
    solutions();
  }
  if (document.querySelector(".p-order-start")) {
    sliderOrderStart();
  }
  if (document.querySelector(".customer.account")) {
    // マイページでの再注文機能初期化
    Reorder.init();
  }
});
